module.exports = __webpack_public_path__ + "static/media/gradienttool.2f03b033.svg";